// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { tgfHooks } from "../framework/hooks/hooks";
import { tbImageFromImage } from "../framework/tbImageFromImage";
import { tgfDictionary } from "../framework/tgfDictionary";
import { s_profile_placeholder } from "./AssetDefinitions/ImageDefinitions";
export var ProfileManager = function () {
    this.profiles = [];
    this.counter = 0;
    this.doneCallback = null;
};
ProfileManager.prototype.loadImage = function (id, url) {
    "use strict";
    var imageRequest = new Image();
    imageRequest.crossOrigin = 'anonymous';
    imageRequest.onload = this._onDone.bind(this, url, imageRequest, id);
    imageRequest.onerror = this._onError.bind(this, id);
    imageRequest.src = url;
};
ProfileManager.prototype.setImage = function (id, tbImage) {
    "use strict";
    if (!this.profiles[id]) {
        this.profiles[id] = {};
    }
    this.profiles[id].image = tbImage;
};
ProfileManager.prototype.setName = function (id, name) {
    "use strict";
    if (!this.profiles[id]) {
        this.profiles[id] = {};
    }
    this.profiles[id].name = name;
};
// Checks if the data on the specified profile is complete (i.e. missing img or name)
ProfileManager.prototype.checkIfComplete = function (id) {
    "use strict";
    if (!this.profiles[id]) {
        return false;
    }
    if (!this.profiles[id].name || !this.profiles[id].img) {
        return false;
    }
    return true;
};
ProfileManager.prototype.getFirstName = function (id) {
    "use strict;";
    return this.getInfo(id).name;
};
ProfileManager.prototype._onDone = function (url, imageRequest, id) {
    "use strict";
    var _image = tbImageFromImage(url, imageRequest, imageRequest["width"], imageRequest["height"], imageRequest["width"] / 2, imageRequest["height"] / 2);
    if (!this.profiles[id]) {
        this.profiles[id] = {};
    }
    this.profiles[id].image = _image;
    this.triggerCall();
};
// In case we couldn't fetch the profile image (url expired) we use the default one
ProfileManager.prototype._onError = function (id) {
    "use strict";
    if (!this.profiles[id]) {
        this.profiles[id] = {};
    }
    this.profiles[id].image = s_profile_placeholder;
    this.triggerCall();
};
ProfileManager.prototype.exists = function (id) {
    "use strict";
    if (this.profiles[id]) {
        return true;
    }
    else {
        return false;
    }
};
ProfileManager.prototype.getInfo = function (id) {
    "use strict";
    if (this.profiles[id]) {
        return this.profiles[id];
    }
    else {
        return {
            name: tgfDictionary.getText('OPPONENT_TEXT'),
            image: s_profile_placeholder
        };
    }
};
ProfileManager.prototype.triggerCall = function () {
    "use strict";
    if (this.doneCallback && this.counter > 0) {
        this.counter--;
    }
    if (this.doneCallback && this.counter === 0) {
        this.doneCallback();
        this.doneCallback = null;
        console.log("done loading external images");
    }
};
ProfileManager.prototype.threadLoader = function (data, doneCall) {
    "use strict";
    this.doneCallback = doneCall;
    this.counter = 0;
    if (!data) {
        this.triggerCall();
        return;
    }
    var initPlayer = data["initiatingPlayerData"];
    var opponent = data["otherPlayerData"];
    if (initPlayer && initPlayer["id"] !== tgfHooks.getPlayerID() && !this.profiles[initPlayer["id"]]) {
        this.loadImage(initPlayer["id"], initPlayer["img"]);
        this.setName(initPlayer["id"], initPlayer["name"]);
        this.counter++;
    }
    else {
        if (opponent && opponent["id"] !== "" && !this.profiles[opponent["id"]]) {
            this.loadImage(opponent["id"], opponent["img"]);
            this.setName(opponent["id"], opponent["name"]);
            this.counter++;
        }
        else {
            console.log("no info");
        }
    }
    if (this.counter === 0) {
        this.triggerCall();
    }
};
ProfileManager.prototype.batchLoad = function (data, doneCall) {
    "use strict";
    this.doneCallback = doneCall;
    this.counter = 0;
    if (Object.keys(data).length > 0) {
        var matches = Object.keys(data);
        var length = Object.keys(data).length;
        for (var i = 0; i < length; i++) {
            var matchId = String(matches[i]);
            var matchData = data[matchId];
            if (matchData["lobby"]["initiatingPlayerData"]["id"] && matchData["lobby"]["initiatingPlayerData"]["id"] !== tgfHooks.getPlayerID() && !this.profiles[matchData["lobby"]["initiatingPlayerData"]["id"]]) {
                this.loadImage(matchData["lobby"]["initiatingPlayerData"]["id"], matchData["lobby"]["initiatingPlayerData"]["img"]);
                this.setName(matchData["lobby"]["initiatingPlayerData"]["id"], matchData["lobby"]["initiatingPlayerData"]["name"]);
                this.counter++;
            }
            else {
                if (matchData["lobby"]["otherPlayerData"]["id"] && matchData["lobby"]["otherPlayerData"]["id"] !== "" && !this.profiles[matchData["lobby"]["otherPlayerData"]["id"]]) {
                    this.loadImage(matchData["lobby"]["otherPlayerData"]["id"], matchData["lobby"]["otherPlayerData"]["img"]);
                    this.setName(matchData["lobby"]["otherPlayerData"]["id"], matchData["lobby"]["otherPlayerData"]["name"]);
                    this.counter++;
                }
                else {
                    //this.triggerCall();
                    console.log("no info");
                }
            }
        }
        if (this.counter === 0) {
            this.triggerCall();
        }
    }
};
ProfileManager.prototype.scaler = function (image, size) {
    "use strict";
    var scale = 1;
    var width;
    if (!image.texture["orig"]) {
        width = image.width;
    }
    else {
        width = image.texture["orig"]["width"];
    }
    scale = size / width;
    return scale;
};
